import React, { Component } from 'react';
import { Grid, GridColumn as Column, GridToolbar } from '@progress/kendo-react-grid';
import '@progress/kendo-theme-default/dist/all.css';
import { filterBy, orderBy } from '@progress/kendo-data-query';
import { ExcelExport, ExcelExportColumn } from '@progress/kendo-react-excel-export';
import { connect } from 'react-redux';
import {
	addAdminUser,
	getPermissions,
	deleteUser,
	updateAdminUser
} from '../../../../../Redux/Actions/Admin/ManageUserActions';
import { toastr } from '../../../../../Redux/Actions/CommonActions';
import { Switch } from '@progress/kendo-react-inputs';
import { Alert } from 'reactstrap';
import AdminHeader from '../../../AdminHeader/AdminHeader';
import cellWithEditing from './CellWithEditing';
import UserForm from './UserForm';
import Search from '../../../Search';
import IsLoading from '../../../../Shared/Loading/IsLoading';
import './ManageUser.scss';
import GridPhoneFormatter from '../../../GridPhoneFormatter';
import { ROOT_API_URL } from '../../../../../api-config';
import axios from 'axios';
import { UsersLoader } from './UsersLoader';
import '../ManageUsers/ManageUser.scss';
import { auth } from '../../../../../services';
import DialogContainer from './Dialogs/DialogContainer';
import Modal from 'react-modal';

const FileDownload = require('js-file-download');
const role = 'Internal';

class MangeUsers extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            isSubmitted: false,
            userInEdit: {},
            isPopupVisible: false,
            permissions: [],
            users: { data: [], total: 0 },
            dataState: {
                take: 10,
                skip: 0,
                filter: {
                    logic: "and",
                    filters: [{ field: "isActive", operator: "eq", value: true }]
                },
                sort: [{ field: "fullName", dir: "asc" }]
            },
            alertVisible: false,
            alertColor: "danger",
            alertMessage: ""
        };
    }

    componentWillMount() {
        this.props.getPermissions(role);
    }

    dataStateChange = (e) => {
        if (e.data && e.data.filter && e.data.filter.filters) {
            var filters = e.data.filter.filters;

            for (var i = 0; i < filters.length; i++) {
                if (filters[i].value == null) {
                    filters[i].value = "";
                }
            }
        }

        this.setState({
            ...this.state,
            dataState: e.data
        });
    }

    dataRecieved = (usersFetched) => {
        this.setState({
            ...this.state,
            users: usersFetched,
            isLoading: false
        });

        if (usersFetched.total == 0 && document.getElementsByClassName("k-grid-header-wrap").length != 0) {
            let t = document.getElementsByClassName("k-grid-header-wrap")[0].className = "horizontal-scroll";
        }
        else if (usersFetched.total != 0 && document.getElementsByClassName("horizontal-scroll").length != 0) {
            document.getElementsByClassName("horizontal-scroll")[0].className = "k-grid-header-wrap";
        }
    }

    addNew = () => {
        this.setState({
            userInEdit: {},
            isPopupVisible: true
        })
    }

    edit = (dataItem) => {
        var url = `${ROOT_API_URL}/ManageUsers/GetPermissionsForUser?userId=${dataItem.userID}`;
        const options = { method: 'GET', headers: auth.authHeader() };

        axios.get(url, options)
            .then((response) => {
                let data = this.cloneUser(dataItem);
                data.state = {
                    id: dataItem.mailingStateId,
                    name: dataItem.state
                };

                data.permissions = response.data;
                this.setState({
                    userInEdit: data,
                    isPopupVisible: true
                })
            }).catch((error) => {
                var err = error && error.data ? error.data.message : 'Unable to edit user.';

                this.setState({
                    alertVisible: true,
                    alertColor: "danger",
                    alertMessage: err
                });
            });
    };
    cloneUser(user) {
        return Object.assign({}, user);
    }

    cancel = () => {
        this.setState({ isPopupVisible: false })
    };

    stringifyObj = (arr) => {
        let t = [...arr];
        if (!t) {
            return null;
        }
        else {
            for (var i = 0; i < t.length; i++) {
                var element = { ...t[i] };
                for (var key in t[i]) {
                    element[key] = element[key] + '';
                }
                t[i] = element;
            }
            return t;
        }
    }

    exportToExcel = () => {
        var Filters = this.state.dataState.filter ? this.stringifyObj([...this.state.dataState.filter.filters]) : null;
        var Sorts = this.state.dataState.sort ? this.stringifyObj([...this.state.dataState.sort]) : null;
        var KendoGridQuery = {
            Filters: Filters.slice(),
            Sorts: Sorts.slice()
        }
        var KendoGridQuery = {
            Filters: Filters ? Filters.slice() : [],
            Sorts: Sorts ? Sorts.slice() : []
        }

        axios.get(ROOT_API_URL + "/ManageUsers/ExportToExcel?queryArguments=" + JSON.stringify(KendoGridQuery), { headers: auth.authHeader() })
            .then((response) => {
                FileDownload(response.data, 'Staff.csv');
            }).catch((error) => {
                var err = error && error.data ? error.data.message : 'Unable to export to excel.';

                this.setState({
                    isSubmitted: false,
                    alertVisible: true,
                    alertColor: "danger",
                    alertMessage: err
                });
            });
    }

    toggleActive = (dataItem) => {
        this.setState({
            isSubmitted: true,
            isLoading: true,
            dataState: {
                take: 10,
                skip: 0,
                filter: {
                    logic: "and",
                    filters: [{ field: "isActive", operator: "eq", value: true }]
                },
                sort: [{ field: "fullName", dir: "asc" }]
            },
        });

        var model = { UserID: dataItem.userID}
        axios
            .post(`${ROOT_API_URL}/ManageUsers/ToggleUserActivity`, model, { headers: auth.authHeader() })
            .then((response) => {
                this.setState({
                    isSubmitted: false
                })
            })
            .catch((error) => {
                var err = error && error.data ? error.data.message : 'Unable to delete user.';

                this.setState({
                    isSubmitted: false,
                    alertVisible: true,
                    alertColor: "danger",
                    alertMessage: err
                });
            });
    };

    modify = (model) => {
        this.setState({
            isSubmitted: true,
            isLoading: true,
            dataState: {
                take: 10,
                skip: 0,
                filter: {
                    logic: "and",
                    filters: [{ field: "isActive", operator: "eq", value: true }]
                },
                sort: [{ field: "fullName", dir: "asc" }]
            },
        });
        axios
            .post(`${ROOT_API_URL}/ManageUsers/ModifyInternalUser`, model, { headers: auth.authHeader() })
            .then((response) => {
                this.setState({
                    isSubmitted: false
                })
            })
            .catch((error) => {
                var err = error && error.data ? error.data.message : 'Unable to modify the internal user.';

                this.setState({
                    isSubmitted: false,
                    alertVisible: true,
                    alertColor: "danger",
                    alertMessage: err
                });
            });
    }



    add = (model) => {
        this.setState({
            isSubmitted: true,
            isLoading: true,
            dataState: {
                take: 10,
                skip: 0,
                filter: {
                    logic: "and",
                    filters: [{ field: "isActive", operator: "eq", value: true }]
                },
                sort: [{ field: "fullName", dir: "asc" }]
            },
        });
        axios
            .post(`${ROOT_API_URL}/ManageUsers/AddInternalUser`, model, { headers: auth.authHeader() })
            .then((response) => {
                this.setState({
                    isSubmitted: false
                })
            })
            .catch((error) => {
                var err = error && error.data ? error.data.message : 'Unable to add the internal user.';

                this.setState({
                    isSubmitted: false,
                    alertVisible: true,
                    alertColor: "danger",
                    alertMessage: err
                });
            });
    }

    pageChange = (event) => {
        this.setState({
            skip: event.page.skip,
            take: event.page.take
        });
    }

    render() {
        return (
            <div id={"users-grid"}>
                <AdminHeader />
                {this.state.isLoading ?
                    (<div>
                        <IsLoading message="Loading staff" />
                    </div>

                    ) :
                    (
                        <div>
                            <Alert
                                color={this.state.alertColor}
                                isOpen={this.state.alertVisible}
                                toggle={() => {
                                    this.setState({ alertVisible: false, alertMessage: "" })
                                }}
                            >
                                {this.state.alertMessage}
                            </Alert>
                            <Grid
                                style={{ width: '80vw', height: '80vh' }}
                                filterable={true}
                                sortable={true}
                                pageable={true}
                                total={this.state.users.total}
                                {...this.state.dataState}
                                {...this.state.users}
                                onDataStateChange={this.dataStateChange}
                            >
                                <GridToolbar>
                                    {/*<div className="admin-grid-toolbar-box1">
                                        <Search customFunc={this.filterSize} />
                                        <Switch
                                            // style="width:70px"
                                            filter="boolean"
                                            onChange={this.handleChange}
                                            onLabel={'Active'}
                                            offLabel={'InActive'}
                                            checked={this.state.toggled}
                                        />
                                    </div>*/}

                                    <div className="admin-grid-toolbar-box2">
                                        <button onClick={this.addNew} className="admin-k-button">
                                            <i className="fas fa-plus-circle"></i>
                                            <span>ADD NEW</span>
                                        </button>
                                        <a id="excel-ref" href={ROOT_API_URL + "/ManageUsers/ExportToExcel"} display="none" download></a>
                                        <button title="Export PDF" className="admin-k-button" onClick={this.exportToExcel}>
                                            <i className="fas fa-file-export"></i>
                                            EXPORT TO EXCEL
                                        </button>
                                    </div>
                                </GridToolbar>
                                <Column filterable={false} cell={cellWithEditing(this.edit, this.toggleActive)} />
                                <Column field="firstName" title="First Name" filter="text" />
                                <Column field="lastName" title="Last Name" filter="text" />
                                <Column field="permissions" title="Permissions" filter="text" />
                                <Column field="email" title="Email" filter="text" format="{0:c}" />
                                {/* <Column field="LastLogin"  filter="date" format="{0:d}" /> */}
                                <Column field="phone" title="Phone" filter="text" cell={GridPhoneFormatter} />
                                <Column field="isActive" title="Is Active" filter="boolean"/>
                            </Grid>
                        </div>
                    )
                }
                <div>
                    {!this.state.isSubmitted ?
                        <UsersLoader
                            dataState={this.state.dataState}
                            onDataRecieved={this.dataRecieved}
                        />
                        : ""
                    }
                </div>
                <div>
                    {
                        this.state.isPopupVisible ? (
                            <Modal
                                isOpen={Boolean(this.state.userInEdit)}
                                onRequestClose={this.cancel}
                                contentLabel="Example Modal"
                                ariaHideApp={false}
                                style={{
                                    content: {
                                        top: '50%',
                                        left: '50%',
                                        right: 'auto',
                                        bottom: 'auto',
                                        marginRight: '-50%',
                                        minWidth: '80vw',
                                        maxWidth: '80vw',
                                        minHeight: '80vh',
                                        maxHeight: '80vh',
                                        overflow: 'auto',
                                        transform: 'translate(-50%, -50%)',
                                        borderRadius: '5px'
                                    }
                                }}
                            >
                                <DialogContainer
                                    dataItem={this.state.userInEdit}
                                    modify={this.modify}
                                    add={this.add}
                                    cancel={this.cancel}
                                    permissions={this.props.user.permissions}
                                //showToast={this.showToast}
                                />
                            </Modal>
                        ) : ""
                    }



                    {/*
                        this.state.isPopupVisible ? (
                            <UserForm
                                dataItem={this.state.userInEdit}
                                modify={this.modify}
                                add={this.add}
                                cancel={this.cancel}
                                permissions={this.props.user.permissions}
                            />
                        ) : ""
                    */}
                </div>
            </div>

        );
    }
}

function mapStateToProps(state) {
	return {
		user: state.user,
        common: state.common,
        authentication: state.authentication
	};
}

export default connect(mapStateToProps, {
	addAdminUser,
	getPermissions,
	deleteUser,
	updateAdminUser,
	toastr
})(MangeUsers);
